<mat-toolbar color="primary" class="custom-primary customer">
  <div class="center-content">
    <span>
      <img class="logo" src="assets/images/logo.png" alt="" />
    </span>
    <a *ngIf="stepsValid[0]"
      href="https://api.whatsapp.com/send?phone=5511970840994&text=Olá, gostaria de mais informações sobre o App da Colloca"
      class="whatsapp" target="_blank" title="Fale conosco no WhatsApp">
      <img src="assets/images/whatsapp.png" alt="WhatsApp" />
    </a>
  </div>
</mat-toolbar>
<div class="container">
  <mat-card class="mat-elevation-z6">
    <mat-card-header style="text-align: center">
      <mat-card-title>
        <span> Complete os 4 passos para se candidatar </span>
      </mat-card-title>
    </mat-card-header>

    <ng-container *ngIf="continueRegister">
      <p class="helper">
        Por favor, verifique se as suas informações estão corretas!
      </p>
    </ng-container>

    <ng-container *ngIf="!(isSmallScreen$ | async); else mobileSteps">
      <mat-vertical-stepper [linear]="isLinearSteep" #stepper>
        <mat-step label="Informações Iníciais" [stepControl]="stepOne">
          <app-step-one (formObserver)="onStepOne($event)" (submit)="stepsValid[0] = true"
            [initData]="continueDataEvent"></app-step-one>
        </mat-step>
        <mat-step label="Informações Básicas" [stepControl]="stepTwo">
          <app-step-two (formObserver)="onStepTwo($event)" (submit)="submitStepTwo()"
            [initData]="continueDataEvent"></app-step-two>
        </mat-step>
        <mat-step label="Informações Profissionais">
          <app-step-three [initData]="continueDataEvent"></app-step-three>
        </mat-step>
        <mat-step label="Informações Educacionais">
          <app-step-four></app-step-four>
        </mat-step>
        <!-- <mat-step label="Plano">
          <app-finish (submit)="stepsValid[2] = true"></app-finish>
        </mat-step> -->
      </mat-vertical-stepper>
    </ng-container>

    <ng-template #mobileSteps>
      <mat-horizontal-stepper [linear]="isLinearSteep" #stepper>
        <mat-step [stepControl]="stepOne">
          <app-step-one (formObserver)="onStepOne($event)" (submit)="stepsValid[0] = true"
            [initData]="continueDataEvent"></app-step-one>
        </mat-step>
        <mat-step [stepControl]="stepTwo">
          <app-step-two (formObserver)="onStepTwo($event)" (submit)="stepsValid[1] = true"
            [initData]="continueDataEvent"></app-step-two>
        </mat-step>
        <mat-step>
          <app-step-three (formObserver)="onStepThree($event)" [initData]="continueDataEvent"></app-step-three>
        </mat-step>
        <mat-step>
          <app-step-four></app-step-four>
        </mat-step>
        <!-- <mat-step>
          <app-finish (submit)="handleFinishSubmit($event)"></app-finish>
        </mat-step> -->
      </mat-horizontal-stepper>
    </ng-template>

    <!-- <div class="actions">
            <button class="custom-primary" mat-raised-button (click)="doneAll()" [disabled]="!isComplete()">Concluir</button>
        </div> -->
  </mat-card>
</div>